import { render, staticRenderFns } from "./ModeMenuItem.vue?vue&type=template&id=0ed125de&scoped=true"
import script from "./ModeMenuItem.vue?vue&type=script&lang=js"
export * from "./ModeMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed125de",
  null
  
)

export default component.exports